import { Fragment } from "react";
import {
  List,
  ListItem,
  ListItemIcon,
  ListSubheader,
  Typography,
} from "@material-ui/core";

import { ServiceReservation } from "../../../graphql/models";

import EventIcon from "@material-ui/icons/Event";
import OpacityIcon from "@material-ui/icons/Opacity";
import MoneyIcon from "@material-ui/icons/Money";
import { useFormatter } from "../../../hooks";

export type MamacleanReservationInfoboxProps = {
  reservation: ServiceReservation;
};

export function MamacleanReservationInfobox(
  props: MamacleanReservationInfoboxProps
) {
  const { reservation } = props;
  const { currency } = useFormatter();

  if (!reservation.externalClientReservationData) {
    return <Typography variant="caption">Nessun dato disponibile.</Typography>;
  }

  const { details } = reservation.externalClientReservationData;

  return (
    <Fragment>
      {details?.map((order) => (
        <List
          style={{ width: "100%" }}
          subheader={
            <ListSubheader component="div">
              Prenotazione MamaClean #{order.orderCode}
            </ListSubheader>
          }
        >
          <ListItem>
            <ListItemIcon>
              <OpacityIcon />
            </ListItemIcon>
            <Typography variant="caption">
              {order.pickedItems.join(", ")}
            </Typography>
          </ListItem>
          {order.estimatedPickupDate && (
            <ListItem>
              <ListItemIcon>
                <EventIcon />
              </ListItemIcon>
              <Typography variant="caption">
                Ritiro il:{" "}
                {new Date(order.estimatedPickupDate).toLocaleDateString()}
              </Typography>
            </ListItem>
          )}
          {order.estimatedDeliveryDate && (
            <ListItem>
              <ListItemIcon>
                <EventIcon />
              </ListItemIcon>
              <Typography variant="caption">
                Consegna prevista il:{" "}
                {new Date(order.estimatedDeliveryDate).toLocaleDateString()}
              </Typography>
            </ListItem>
          )}
          {order.totalPrice && (
            <ListItem>
              <ListItemIcon>
                <MoneyIcon />
              </ListItemIcon>
              <Typography variant="h6">
                Prezzo finale: {currency(order.totalPrice / 100)}
              </Typography>
            </ListItem>
          )}
        </List>
      ))}
    </Fragment>
  );
}
